import React, { useMemo } from "react";
import {
  createGoogleCalendarUrl,
  createOutlookCalendarUrl,
  downloadIcsFile,
  validateCalendarEvent,
} from "../../utils/calendarEventUtils";
import "./add-to-calendar.css";

const CALENDAR_PROVIDERS = {
  google: { id: "calendar-google", label: "Google Calendar" },
  outlook: { id: "calendar-outlook", label: "Outlook Calendar" },
  ics: { id: "calendar-ics", label: "Apple or other calendar" },
};

function AddToCalendar({
  title,
  startUtc,
  endUtc,
  timezone,
  location,
  description,
  publicEventUrl,
  onProviderSelect,
}) {
  const calendar = useMemo(() => {
    const calendarEvent = {
      title,
      startUtc,
      endUtc,
      timezone,
      location,
      description,
      publicEventUrl,
    };

    try {
      validateCalendarEvent(calendarEvent);
      return {
        event: calendarEvent,
        googleUrl: createGoogleCalendarUrl(calendarEvent),
        outlookUrl: createOutlookCalendarUrl(calendarEvent),
      };
    } catch {
      return null;
    }
  }, [description, endUtc, location, publicEventUrl, startUtc, timezone, title]);

  if (!calendar) return null;

  const trackSelection = (provider) => {
    onProviderSelect?.(provider);
  };

  const handleIcsDownload = () => {
    trackSelection(CALENDAR_PROVIDERS.ics);
    downloadIcsFile(calendar.event);
  };

  return (
    <section className="dynamic-event-page__calendar" aria-label="Add to calendar">
      <h3>Add to your calendar</h3>
      <div className="dynamic-event-page__calendar-options">
        <a
          className="dynamic-event-page__calendar-option"
          href={calendar.googleUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackSelection(CALENDAR_PROVIDERS.google)}
        >
          Google Calendar
        </a>
        <a
          className="dynamic-event-page__calendar-option"
          href={calendar.outlookUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackSelection(CALENDAR_PROVIDERS.outlook)}
        >
          Outlook
        </a>
        <button
          className="dynamic-event-page__calendar-option dynamic-event-page__calendar-option--download"
          type="button"
          onClick={handleIcsDownload}
        >
          Apple / other (.ics)
        </button>
      </div>
    </section>
  );
}

export default AddToCalendar;
